import en from "./en.json";
import it from "./it.json";

const auth = { en, it };

export default auth;
